import { TeiaSearchFilter } from '@stereograph/teia-system-design/utils';

export const teiaQuantityTakeoffQueryKeys = {
  columns: ['quantityTakeOff', 'columns'] as const,
  objects: (
    rule: TeiaSearchFilter,
    columns: Array<string>,
    groupBy: string,
    pageIndex: number,
    pageSize: number,
    orderDirection: string,
    orderBy?: string,
  ) =>
    [
      'quantityTakeOff',
      'objects',
      {
        rule,
        columns,
        groupBy,
        pageIndex,
        pageSize,
        orderDirection,
        orderBy,
      },
    ] as const,
  download: (rule: TeiaSearchFilter, columns: Array<string>, groupBy: string) =>
    [
      'quantityTakeOff',
      'objects',
      'export',
      {
        rule,
        columns,
        groupBy,
      },
    ] as const,
};
